import { createAction } from '@ngrx/store';

export const convertRegistration = createAction('[Convert Registration] Load Convert Endpoint');

export const convertRegistrationFail = createAction('[Convert Registration] Convert Endpoint Fail');

export const convertRegistrationSuccess = createAction(
  '[Convert Registration] Convert Endpoint Success',
);
